<template>
    <div class="architecture">
        <LeftContent :defaultTreeObj="defaultTreeObj" />
        <RightContent :defaultTreeObj="defaultTreeObj" />
        <sensorDetailDialog></sensorDetailDialog>
        <gatewayDetailDialog></gatewayDetailDialog>
        <displayDetailDialog></displayDetailDialog>
        <relayDetailDialog></relayDetailDialog>
    </div>
</template>

<script>
import LeftContent from './components/arch/tree/LeftContent.vue';
import RightContent from './components/arch/right/RightContent-mf.vue';
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog';
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog';
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog';
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog';
export default {
    components: {
        LeftContent,
        RightContent,
        sensorDetailDialog,
        gatewayDetailDialog,
        displayDetailDialog,
        relayDetailDialog
    },
    data() {
        return {
            defaultTreeObj: {}
        };
    },
    created() {
        this.getDefaultTree();
    },
    methods: {
        getDefaultTree() {
            let array;
            if (this.$store.state.type === 3 || this.$store.state.type === 2) {
                array = this.$store.state.SchemaTree.slice(1);
            } else {
                // 这里不能使用getters获取
                array = this.$store.state.SchemaTree;
            }
            this.defaultTreeObj = array[0];
        }
    }
};
</script>

<style lang="scss" scoped>
.architecture {
    height: 100%;
    display: flex;
    background-color: #ffffff;
}
</style>
